import { z } from 'zod';
import { LogicOperatorEnum, OperatorTypeEnum, TriggerTypeEnum } from '../taxonomy';
import { JsonValueSchema } from './common';

export const StepConditionSchema = z.object({
  field: TriggerTypeEnum,
  operator: OperatorTypeEnum,
  value: JsonValueSchema,
});

export const StepConditionGroupSchema = z.object({
  logic: LogicOperatorEnum.default('AND'),
  conditions: z.array(StepConditionSchema),
});

export const StepHookSchema = z.object({
  logic: LogicOperatorEnum.default('AND'),
  groups: z.array(StepConditionGroupSchema),
});

// Note: the `StepCondition`, `StepConditionGroup`, and `StepHook` TS types are
// owned by `../types` (canonical). They are intentionally not re-declared here
// to avoid an ambiguous `export *` re-export collision in the package index.
